import { createApi } from '@reduxjs/toolkit/query/react';

import { apiSahBudgets } from '~constants/api';

import { rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';

import { Tracker } from '~support-at-home/models';

export const typePrefix = `clients-budgets-tracker`;

export type BudgetTrackerReq = {
  id: string;
  [key: string]: unknown;
};

export const budgetTrackerApi = createApi({
  reducerPath: 'budgetTrackerApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiSahBudgets }),
  tagTypes: ['budget-tracker'],
  endpoints: (builder) => ({
    getBudgetTracker: builder.query<Tracker, BudgetTrackerReq | void>({
      query: (params) => {
        const { id, ...rest } = (params ?? {}) as BudgetTrackerReq;
        return { url: `/${id}/tracker`, method: 'GET', params: rest };
      },
      providesTags: [{ type: 'budget-tracker', id: 'LIST' }],
      transformResponse: (payload) => unwrap<Tracker>(payload),
    }),
  }),
});

export const { useGetBudgetTrackerQuery } = budgetTrackerApi;
